import React, {useState} from "react";
import cx from 'classnames';
import {Button, Modal, Space} from "antd";
import moment from "moment";
import {useRouter} from "next/router";
import {useCountDown} from "ahooks";
import {FcrpdPaperStatus, PlanStatus, TExamKind} from "@/types";
import {calcExamTitle} from "@/utils";
import ExamArrow from "@/components/ui/exam_arrow";
import UnRealNameWarningModal from "@/components/UnRealNameWarningModal/index";
import styles from './styles.module.less';

const Countdown: React.FC<{
  type: TExamKind;
  startTime: number;
  paperId?: string;
  examId?: string;
}> = ({type, startTime, examId, paperId}) => {
  const [isInEnd, setIsInEnd] = useState(false);
  const [countdown, formattedRes] = useCountDown({
    targetDate: startTime,
    onEnd: () => {
      setIsInEnd(true);
    }
  });
  const {days, hours, minutes, seconds} = formattedRes;
  return (
    <>
      {isInEnd ? (
        <>
          <UnRealNameWarningModal>
            <Button className={styles.exam_plan_wrapper_simple_btn}>参加考试</Button>
          </UnRealNameWarningModal>
          {/*{paperId && examId && (*/}
          {/*  <Link href={`/exam?paperId=${paperId}&examId=${examId}&type=${type}`}>*/}
          {/*    <Button className={styles.exam_plan_wrapper_simple_btn}>参加考试</Button>*/}
          {/*  </Link>*/}
          {/*)}*/}
        </>
      ) : (
        <Space>
          <div className={cx(styles.exam_plan_wrapper_text, styles.color_grey)}>
            {days}天{hours}小时{minutes}分{seconds}秒后
          </div>
          <Space size={0}>
            <div className={cx(styles.exam_plan_wrapper_go_exam, styles.color_blue)}>进入考试</div>
            <ExamArrow/>
          </Space>
        </Space>
      )}
    </>
  )
}

export enum PayState {
  noPay,
  payed,
  payCancel
}

export type TExamPlanItem = {
  id: number;
  paperId?: string;
  examId?: string;
  state: PlanStatus;
  examName: string;
  paperState?: FcrpdPaperStatus;// 试卷状态，用于fcrpd里
  payState: number;
  startTime: number; // 考试开始时间
  endTime?: number; // 考试结束时间
  submit_time?: number; // 用户交卷时间
  publishTime?: number; // 用户通过时间
  appeal_time?: number; // 用户申诉时间
  duration: string; // 考试持续时间
  fullScore: number; // 考试总分
  scoreLine: number; // 考试通过分数
  score?: number; // 用户得分
  schId?: string; // 批次id
  examExpiresTime: number | null; // 考试结束时间
  couponValidity: number | null; // 优惠券有限期
  newPaperState: PlanStatus;
  certName?: string; // 报考期数
  certScoreLine?: number // 认证的总分，用户fcrpd里
}

type TExamPlan = {
  type: TExamKind;
  data: TExamPlanItem[]
}

const ExamPlan: React.FC<TExamPlan> = ({type, data = []}) => {
  const router = useRouter();
  // 未开始时的弹窗提示
  const noStartWarning = (dataItem: TExamPlanItem) => {
    const calcEndTime = () => {
      if (dataItem.schId) {
        return moment(dataItem.endTime)
      }
      return moment(dataItem.startTime).add(dataItem.duration, 'm')
    }
    const {startTime} = dataItem;
    const endTime = calcEndTime();
    if (moment().isBefore(moment(startTime))) {
      Modal.warning({
        width: 500,
        title: '未到考试开始时间',
        content: (
          <div>
            {startTime && endTime && (
              <p>考试时间：<span
                style={{fontWeight: 'bold'}}>{moment(startTime).format('YYYY-MM-DD HH:mm:ss')}至{moment(endTime).format('YYYY-MM-DD HH:mm:ss')}</span>
              </p>
            )}
            <p style={{marginTop: 8}}>请在考试开始后回到本网页进行考试，建议收藏保存网页地址</p>
          </div>
        ),
        onOk() {
        },
      });
    } else {
      router.push({pathname: '/exam', query: {paperId: dataItem.paperId, examId: dataItem.examId, type}})
    }
  }
  const renderIcon = (status: PlanStatus) => {
    switch (status) {
      case PlanStatus.noStart:
      case PlanStatus.examing:
        return '/img/detail/plan/examing.png';
      case PlanStatus.pass:
        return '/img/detail/plan/pass.png';
      case PlanStatus.noPass:
        return '/img/detail/plan/nopass.png';
      case PlanStatus.reviewing:
        return '/img/detail/plan/reviewing.png';
      case PlanStatus.appealing:
        return '/img/detail/plan/appealing.png';
      default:
        return '/img/detail/plan/examing.png';
    }
  }

  const renderText = (status: PlanStatus, item: TExamPlanItem) => {
    switch (status) {
      case PlanStatus.noStart:
      case PlanStatus.examing:
        return (
          <div>
            <Space>
              {/*<span className={cx(styles.exam_plan_wrapper_text, styles.color_grey)}>时长{calcTime(Number(item.duration))}</span>*/}
              <span className={cx(styles.exam_plan_wrapper_text, styles.color_grey)}>满分{item.fullScore}分</span>
              <span className={cx(styles.exam_plan_wrapper_text, styles.color_grey)}>{item.scoreLine}分通过</span>
            </Space>
          </div>
        );
      case PlanStatus.pass:
        return (
          <Space>
            <span
              className={cx(styles.exam_plan_wrapper_text, styles.color_grey)}>{`已于${moment(item.publishTime).format('YYYY-MM-DD')}通过`}</span>
            <Space className={cx(styles.exam_plan_wrapper_text, styles.color_grey)}>
              成绩<span className={styles.color_green}>{item.score}</span>分
            </Space>
          </Space>
        );
      case PlanStatus.noPass:
        return (
          <Space>
            <span className={cx(styles.exam_plan_wrapper_text, styles.color_grey)}>未通过</span>
            <Space className={cx(styles.exam_plan_wrapper_text, styles.color_grey)}>
              成绩<span className={styles.color_red}>{item.score}</span>分
            </Space>
          </Space>
        );
      case PlanStatus.reviewing:
        return (
          <>
            {item.submit_time && (
              <span
                className={cx(styles.exam_plan_wrapper_text, styles.color_grey)}>已于{moment(item.submit_time).format('YYYY-MM-DD HH:mm:ss')}交卷</span>
            )}
          </>
        );
      case PlanStatus.appealing:
        return (
          <span
            className={cx(styles.exam_plan_wrapper_text, styles.color_grey)}>已于{moment(item.appeal_time).format('YYYY-MM-DD HH:mm:ss')}发起成绩申诉</span>
        );
      default:
        return '';
    }
  }

  const renderFooter = (status: PlanStatus, item: TExamPlanItem) => {
    switch (status) {
      case PlanStatus.noStart:
        return (
          <>
            {item.startTime && item.examId && (
              <Countdown type={type} startTime={item.startTime} examId={item.examId} paperId={item.paperId}/>
            )}
          </>
        )
      case PlanStatus.examing:
        return (
          <UnRealNameWarningModal>
            <Button type="primary">进入考试</Button>
          </UnRealNameWarningModal>
        );
      case PlanStatus.noPass:
      case PlanStatus.pass:
        return (
          <Space>
            <span className={cx(styles.exam_plan_wrapper_text, styles.color_blue)}>查看试卷</span>
          </Space>
        );
      case PlanStatus.reviewing:
        return (
          <span className={cx(styles.exam_plan_wrapper_text, styles.color_yellow)}>阅卷中，请耐心等待</span>
        );
      case PlanStatus.appealing:
        return (
          <span className={cx(styles.exam_plan_wrapper_text, styles.color_yellow)}>申诉复审中，请等待管理员联系您</span>
        );
      default:
        return '';
    }
  }
  // 计算整个卡片的点击事件
  const calcClickFun = (status: PlanStatus, item: TExamPlanItem) => {
    let fun = () => {
    };
    switch (status) {
      case PlanStatus.noStart:
        fun = () => {
          noStartWarning(item);
        };
        break;
      case PlanStatus.examing:
        fun = () => {
          if (item.paperId && item.examId) {
            router.push({pathname: '/exam', query: {paperId: item.paperId, examId: item.examId, type}})
          }
        };
        break;
      case PlanStatus.noPass:
      case PlanStatus.pass:
        fun = (
          () => {
            if (item.paperId) {
              router.push({pathname: '/exam/preview', query: {paperId: item.paperId, type}})
            }
          }
        );
        break;
      default:
        fun = () => {
        };
    }
    fun();
  }
  return (
    <div className={styles.exam_plan_wrapper}>
      <div className={styles.exam_plan_wrapper_title}>考试安排 {data.length === 1 ? '' : data.length}</div>
      {data.length === 1 ? (
        <div className={cx(styles.exam_plan_wrapper_item, styles.only_first)} onClick={() => {
          calcClickFun(type === 'fcrpd' ? data[0].newPaperState : data[0].state, data[0]);
        }}>
          <div className={styles.only_first_body}>
            <img src={renderIcon(type === 'fcrpd' ? data[0].newPaperState : data[0].state)} alt="icon"
                 className={styles.only_first_body_img}/>
            <h3 className={cx(styles.only_first_body_title, styles.only_first_body_row)}>{calcExamTitle(type)}</h3>
            <div className={cx(styles.only_first_body_text, styles.only_first_body_row)}>
              {renderText(type === 'fcrpd' ? data[0].newPaperState : data[0].state, data[0])}
            </div>
            <div className={cx(styles.only_first_body_text, styles.only_first_body_row)}>
              {renderFooter(type === 'fcrpd' ? data[0].newPaperState : data[0].state, data[0])}
            </div>
          </div>
        </div>
      ) : (
        <>
          {data?.map(item => {
            return (
              <div className={cx(styles.exam_plan_wrapper_item)} key={item.id} onClick={() => {
                calcClickFun(type === 'fcrpd' ? item.newPaperState : item.state, item)
              }}>
                <Space align="start">
                  <img src={renderIcon(type === 'fcrpd' ? item.newPaperState : item.state)} alt="icon"
                       className={styles.exam_plan_wrapper_item_img}/>
                  <div>
                    <div className={styles.exam_plan_wrapper_item_title}>{item.examName}</div>
                    <div className={styles.exam_plan_wrapper_item_row}>
                      {renderText(type === 'fcrpd' ? item.newPaperState : item.state, item)}
                    </div>
                    <div>{renderFooter(type === 'fcrpd' ? item.newPaperState : item.state, item)}</div>
                  </div>
                </Space>
              </div>
            )
          })}
        </>
      )}
    </div>
  )
}
export default ExamPlan;
